var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailSymbolfileListWrongIcon = function SvgNewcsDashboardCrashanalysisIssuedetailSymbolfileListWrongIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_symbolfile_list_wrong_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M630 861h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 486"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_symbolfile_list_wrong_icon_svg__a)",
    transform: "translate(-630 -861)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M630 868a7 7 0 0 1 7-7 7 7 0 0 1 7 7 7 7 0 0 1-7 7 7 7 0 0 1-7-7m1.2 0a5.806 5.806 0 0 0 5.8 5.8 5.807 5.807 0 0 0 5.8-5.8 5.807 5.807 0 0 0-5.8-5.8 5.807 5.807 0 0 0-5.8 5.8m7.376 2.424L637 868.848l-1.576 1.576a.6.6 0 0 1-.848 0 .6.6 0 0 1-.176-.424.6.6 0 0 1 .176-.425l1.576-1.575-1.576-1.576a.6.6 0 0 1-.176-.424.6.6 0 0 1 .176-.424.6.6 0 0 1 .424-.176.6.6 0 0 1 .424.176l1.576 1.576 1.576-1.576a.6.6 0 0 1 .849 0 .6.6 0 0 1 .175.424.6.6 0 0 1-.175.425L637.848 868l1.576 1.575a.6.6 0 0 1 .175.425.6.6 0 0 1-.175.424.6.6 0 0 1-.424.176.6.6 0 0 1-.424-.176",
    "data-name": "\\u8054\\u5408 79"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailSymbolfileListWrongIcon;